import { apiFetch } from '../../../lib/http';

// Course-share API. Not yet implemented on the backend — the hooks in
// ../hooks/*.js run against ../fixtures/shareStub.js while USE_STUB=true.
// When the backend ships, flip USE_STUB to false and these calls run for real.
//
// Contract (see the course-share backend handoff):
//   POST /api/v1/courses/{courseId}/share   (auth; caller must own course)
//     -> { shareId, token, url, acceptCount }
//   GET  /api/v1/shares/{token}             (PUBLIC — no auth)
//     -> { token, title, summary, difficulty, outline[], creatorDisplayName, acceptCount }
//   POST /api/v1/shares/{token}/accept      (auth + subscription required)
//     -> regenerates a course from the stored spec on the CALLER's account,
//        increments acceptCount -> { courseId, firstLessonId }
//     -> 403 SUBSCRIPTION_REQUIRED if the caller has no active subscription
export const shareApi = {
  // Create (or return the existing canonical) share link for a course the
  // caller owns. Idempotent: re-sharing the same course returns the same token.
  createShare({ courseId, auth = true }) {
    return apiFetch(`/api/v1/courses/${encodeURIComponent(courseId)}/share`, {
      method: 'POST',
      auth,
    });
  },

  // Fetch the public preview for a share token. No auth required to view.
  getShare({ token, auth = false }) {
    return apiFetch(`/api/v1/shares/${encodeURIComponent(token)}`, {
      method: 'GET',
      auth,
    });
  },

  // Accept a share: regenerate the course from its spec on the caller's account.
  acceptShare({ token, auth = true }) {
    return apiFetch(`/api/v1/shares/${encodeURIComponent(token)}/accept`, {
      method: 'POST',
      auth,
    });
  },
};
